import axios from "axios";
import { ModalError, ModalSuccess } from "components";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useHistory, useLocation } from "react-router-dom";
import { getErrors } from "utils";
import { hardBaseUrl } from "../../../services/urlConstant";
import ContractForm from "./Components/ContractForm";

function EditContract() {
  const history = useHistory();
  const { state } = useLocation();
  const { id } = useParams();
  const contractType =
    state?.customer?.category === "song" ? "Song Contract" : "Main Contract";
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: "Bearer " + token,
  };
  const isSongContract = contractType === "Song Contract";
  const urlContract = `${hardBaseUrl}/publisher/contract`;
  const mainContractFormEndpoint = !isSongContract ? "/composer-main" : "";
  const [loadingContract, setLoadingContract] = useState(false);
  const [contractDetailPreload, setContractDetailPreload] = useState({});
  const [documentList, setDocumentList] = useState([]);

  const getDetailContract = async () => {
    try {
      const res = await axios.get(
        `${urlContract}${mainContractFormEndpoint}/${Number(id)}`,
        { headers }
      );
      setContractDetailPreload(res?.data?.data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDocumentList = async () => {
    try {
      const res = await axios.get(
        `${hardBaseUrl}/publisher/contract-document/${Number(id)}`,
        { headers, params: { page: 1, size: 10 } }
      );
      const { data } = res?.data;
      setDocumentList(
        data?.map(item => ({
          ...item,
          file_path: item?.url,
          name: item?.filename,
        })) || []
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const handlSubmitData = async (payload, supportingDocumentFiles) => {
    try {
      setLoadingContract(true);
      let requestData;
      let requestHeaders = { ...headers };

      if (supportingDocumentFiles && supportingDocumentFiles.length > 0) {
        const formData = new FormData();
        const payloadForFormData = {
          ...payload,
          contract_composer_balances: payload.contract_composer_balances
            ? JSON.stringify(payload.contract_composer_balances)
            : "",
          ownership_percentages: JSON.stringify(payload.ownership_percentages),
          publisher_share_percentages: JSON.stringify(
            payload.publisher_share_percentages
          ),
        };
        Object.keys(payloadForFormData).forEach(key => {
          formData.append(key, payloadForFormData[key]);
        });
        supportingDocumentFiles?.map(file =>
          formData.append("documents", file)
        );

        requestData = formData;
      } else {
        requestData = payload;
        requestHeaders["Content-Type"] = "application/json";
      }
      await axios.put(
        `${urlContract}${mainContractFormEndpoint}/${Number(id)}`,
        requestData,
        { headers: requestHeaders }
      );
      ModalSuccess().then(() => history.goBack());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingContract(false);
    }
  };

  const fetchData = async () => {
    setLoadingContract(true);
    const promises = [getDetailContract()];
    promises.push(getDocumentList());

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingContract(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ContractForm
      title="Edit Contract"
      handlSubmitData={handlSubmitData}
      loadingContract={loadingContract}
      stateContractType={contractType}
      preload={contractDetailPreload}
      contractId={id}
      documentList={documentList}
    />
  );
}

export default EditContract;
